import { Box } from "@mui/material"
import { SelectionOptions } from "../../shared/SelectionOptions";
import { ScheduleActionsDate } from "./ScheduleActionsDate";
import { categoryItems } from "../../shared/sharedHelper";
import { getSearchCategory, getSearchDate, updateSearchParamsForCategory, updateSearchParamsForDate } from "./schedulePageHelper";
import { useNavigate, useSearchParams } from "react-router-dom";
import { scheduleRoutesCombined } from "../ScheduleNavigation";

export const ScheduleActions = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const searchDate = getSearchDate(searchParams);
    const searchCategory = getSearchCategory(searchParams);

    // allow parameter to be any
    // eslint-disable-next-line
    const handleDateChange = (e: React.ChangeEvent<any>) => {
        const searchDate = e.target.value;
        const params = updateSearchParamsForDate(searchParams, searchDate);
        navigate({ pathname: scheduleRoutesCombined.main, search: params.toString() });
    }

    const handleSearchCategoryChange = (categoryCode: string) => {
        const params = updateSearchParamsForCategory(searchParams, categoryCode);
        navigate({ pathname: scheduleRoutesCombined.main, search: params.toString() });
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '5px' }}>
            <Box sx={{ display: 'flex', marginTop: '-10px' }}>
                <ScheduleActionsDate
                    date={searchDate ?? new Date()}
                    onChange={handleDateChange}
                />
            </Box>
            <Box sx={{ display: 'flex', padding: '6px 6px 0 12px' }}>
                <SelectionOptions
                    id="actions-category"
                    items={categoryItems}
                    value={searchCategory ?? categoryItems[0].key}
                    onValueChange={(code) => handleSearchCategoryChange(code)}
                />
            </Box>
        </Box>
    )
}
